import './assets/scss/_main.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false

var md = require('markdown-it')()

new Vue({
  router,
  data () {
    return {
      apiKeyAT: 'patCr8bssEb3YmqEh.94e9300084c8732501bfaf174bec531b900ae9e6ca2696b02a36de44ebfa01c4',
      rawData: {},
      compareKits: [],
      loaded: false
    }
  },
  beforeMount () {
    this.getData()
  },
  methods: {
    async getData () {
      const [kits,
        pathogens,
        distributors,
        foodTypes,
        samplingTypes,
        kitValidations,
        detectionLimits,
        disposalRequirements,
        distributorQuestions,
        levelOfTrainingDescriptors,
        easeOfUseDescriptors,
        pageContent] = await Promise.all([
        this.getKits(),
        this.getPathogens(),
        this.getDistributors(),
        this.getFoodTypes(),
        this.getSamplingTypes(),
        this.getKitValidations(),
        this.getDetectionLimits(),
        this.getDisposalRequirements(),
        this.getDistributorQuestions(),
        this.getLevelOfTrainingDescriptors(),
        this.getEaseOfUseDescriptors(),
        this.getPageContent()
      ])
      this.rawData.kits = kits.data.records
      this.rawData.pathogens = pathogens.data.records
      this.rawData.distributors = distributors.data.records
      this.rawData.foodTypes = foodTypes.data.records
      this.rawData.samplingTypes = samplingTypes.data.records
      this.rawData.kitValidations = kitValidations.data.records
      this.rawData.detectionLimits = detectionLimits.data.records
      this.rawData.disposalRequirements = disposalRequirements.data.records
      this.rawData.distributorQuestions = distributorQuestions.data.records
      this.rawData.levelOfTrainingDescriptors = levelOfTrainingDescriptors.data.records
      this.rawData.easeOfUseDescriptors = easeOfUseDescriptors.data.records
      this.rawData.pageContent = pageContent.data.records
      this.loaded = true
    },
    getPageContent () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Pages', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getKits () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Kit', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getPathogens () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Pathogen', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getDistributors () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Distributor', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getFoodTypes () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Food%20Type', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getSamplingTypes () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Sampling%20Type', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getKitValidations () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Kit%20Validation', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getDetectionLimits () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Detection%20Limits', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getDisposalRequirements () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Disposal%20Requirements', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getDistributorQuestions () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Questions%20For%20Distributors', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getLevelOfTrainingDescriptors () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Level%20Of%20Training%20Descriptors', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getEaseOfUseDescriptors () {
      return axios.get('https://api.airtable.com/v0/apphsFMDYYxKPMEmF/Ease%20Of%20Use%20Descriptors', {
        params: { view: 'Grid view' },
        headers: { Authorization: 'Bearer ' + this.apiKeyAT }
      })
    },
    getKitValidationStandardsObj (kit) {
      if (kit.fields['Kit Validations'] !== undefined) {
        var validations = []
        this.kitValidations.forEach(standard => {
          kit.fields['Kit Validations'].forEach(kitStandard => {
            if (standard.id === kitStandard) {
              var obj = {
                id: standard.id,
                name: standard.name
              }
              validations.push(obj)
            }
          })
        })
        return validations
      } else {
        return undefined
      }
    },
    getDetectionLimitsObj (kit) {
      if (kit.fields['Detection Limits'] !== undefined) {
        var detectionLimits = []
        this.detectionLimits.forEach(limit => {
          kit.fields['Detection Limits'].forEach(kitLimit => {
            if (limit.id === kitLimit) {
              var obj = {
                id: limit.id,
                name: limit.name
              }
              detectionLimits.push(obj)
            }
          })
        })
        return detectionLimits
      } else {
        return undefined
      }
    },
    getDistributorObj (kit) {
      var obj = {}
      if (kit.fields.Distributor !== undefined) {
        this.distributors.forEach(distributor => {
          kit.fields.Distributor.forEach(thing => {
            if (distributor.id === thing) {
              obj = {
                id: distributor.id,
                name: distributor.name,
                country: distributor.country,
                website: distributor.website.split(',')
              }
            }
          })
        })
        return obj
      } else {
        return undefined
      }
    },
    getPathogensObj (kit) {
      if (kit.fields.Pathogen !== undefined) {
        var lcPathogens = []
        this.pathogens.forEach(pathogen => {
          kit.fields.Pathogen.forEach(kitPathogen => {
            if (pathogen.id === kitPathogen) {
              var obj = {
                id: pathogen.id,
                name: pathogen.name
              }
              lcPathogens.push(obj)
            }
          })
        })
        return lcPathogens
      } else {
        return undefined
      }
    },
    getSamplingTypesObj (kit) {
      if (kit.fields['Sampling Type'] !== undefined) {
        var lcSamplingTypes = []
        this.samplingTypes.forEach(type => {
          kit.fields['Sampling Type'].forEach(kitType => {
            if (type.id === kitType) {
              var obj = {
                id: type.id,
                name: type.name
              }
              lcSamplingTypes.push(obj)
            }
          })
        })
        return lcSamplingTypes
      } else {
        return undefined
      }
    },
    getFoodTypesObj (kit) {
      if (kit.fields['Food Types'] !== undefined) {
        var lcFoodTypes = []
        this.foodTypes.forEach(type => {
          kit.fields['Food Types'].forEach(foodType => {
            if (type.id === foodType) {
              var obj = {
                id: type.id,
                name: type.name
              }
              lcFoodTypes.push(obj)
            }
          })
        })
        return lcFoodTypes
      } else {
        return undefined
      }
    },
    getDisposalRequirementsObj (kit) {
      if (kit.fields['Disposal Requirements'] !== undefined) {
        var lcDisposalRequirements = []
        this.disposalRequirements.forEach(requirement => {
          kit.fields['Disposal Requirements'].forEach(kitRequirement => {
            if (requirement.id === kitRequirement) {
              var obj = {
                id: requirement.id,
                name: requirement.name
              }
              lcDisposalRequirements.push(obj)
            }
          })
        })
        return lcDisposalRequirements
      } else {
        return undefined
      }
    },
    shuffle (a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    }
  },
  computed: {
    kits () {
      const kits = []
      this.rawData.kits.forEach(kit => {
        if (kit.fields.Product !== undefined) {
          kits.push({
            id: kit.id,
            product: kit.fields.Product,
            name: kit.fields.Name,
            pathogens: kit.fields.Pathogen,
            pathogensInfo: this.getPathogensObj(kit),
            distributor: kit.fields.Distributor[0],
            distributorInfo: this.getDistributorObj(kit),
            website: kit.fields.Website,
            instructions: kit.fields.Instructions,
            kitUsage: kit.fields['Kit Usage'],
            laboratory: kit.fields['Kit Usage'].some(usage => usage === 'Laboratory'),
            inHouse: kit.fields['Kit Usage'].some(usage => usage === 'In House'),
            turnaroundTime: kit.fields['Turnaround Time'],
            samplingTypes: this.getSamplingTypesObj(kit),
            environmental: !!+kit.fields.EnvironmentalBool,
            food: !!+kit.fields.FoodBool,
            foodTypes: this.getFoodTypesObj(kit),
            kitValidationStandards: this.getKitValidationStandardsObj(kit),
            kitValidated: !!+kit.fields.KitValidationsBool,
            ongoingValidation: !!+kit.fields.OngoingValidationBool,
            controlsRequired: !!+kit.fields.ControlsRequiredBool,
            detectionLimits: this.getDetectionLimitsObj(kit),
            testSensitivity: kit.fields['test Sensitivity'],
            testSpecifityNZ: kit.fields['Test Specificity for NZ strains'],
            confirmationPositiveResult: !!+kit.fields.ConfirmationPositiveResultBool,
            confirmationDescription: kit.fields['Confirmation Description'],
            staffTimeInvolvement: kit.fields['Staff Time Involvement'] === undefined ? '-' : Math.round(kit.fields['Staff Time Involvement'] / 60) + ' minute(s)',
            establishmentCost: !!+kit.fields.EstablishmentCostBool,
            establishmentCostDescription: kit.fields['Establishment Cost Description'],
            easeOfUse: kit.fields['Ease of Use'] === undefined ? '0' : kit.fields['Ease of Use'].toString(),
            levelOfTraining: kit.fields['Level of Training'] === undefined ? '0' : kit.fields['Level of Training'].toString(),
            equipmentNeeded: kit.fields['Equipment Needed'],
            labRequirements: !!+kit.fields.LabRequirementsBool,
            labRequirementsDescription: kit.fields['Lab Requirements Description'],
            disposalRequirements: this.getDisposalRequirementsObj(kit),
            otherInformation: kit.fields['Other Information']
          })
        }
      })
      return this.shuffle(kits)
    },
    pathogens () {
      const pathogens = []
      this.rawData.pathogens.forEach(pathogen => {
        pathogens.push({
          id: pathogen.id,
          name: pathogen.fields.Name,
          kits: pathogen.fields.Kits
        })
      })
      return pathogens
    },
    distributors () {
      const distributors = []
      this.rawData.distributors.forEach(distributor => {
        distributors.push({
          id: distributor.id,
          name: distributor.fields.Name,
          country: distributor.fields.Country,
          kits: distributor.fields.Kits,
          website: distributor.fields['Website URL']
        })
      })
      return distributors
    },
    samplingTypes () {
      const samplingTypes = []
      this.rawData.samplingTypes.forEach(samplingType => {
        samplingTypes.push({
          id: samplingType.id,
          name: samplingType.fields.Type,
          kits: samplingType.fields.Kits
        })
      })
      return samplingTypes
    },
    foodTypes () {
      const foodTypes = []
      this.rawData.foodTypes.forEach(foodType => {
        foodTypes.push({
          id: foodType.id,
          name: foodType.fields.Name,
          kits: foodType.fields.Kits
        })
      })
      return foodTypes
    },
    kitValidations () {
      const kitValidations = []
      this.rawData.kitValidations.forEach(kitValidation => {
        kitValidations.push({
          id: kitValidation.id,
          name: kitValidation.fields.Name,
          kits: kitValidation.fields.Kits
        })
      })
      return kitValidations
    },
    detectionLimits () {
      const detectionLimits = []
      this.rawData.detectionLimits.forEach(detectionLimit => {
        detectionLimits.push({
          id: detectionLimit.id,
          name: detectionLimit.fields.Name,
          kits: detectionLimit.fields.Kits
        })
      })
      return detectionLimits
    },
    disposalRequirements () {
      const disposalRequirements = []
      this.rawData.disposalRequirements.forEach(disposalRequirement => {
        disposalRequirements.push({
          id: disposalRequirement.id,
          name: disposalRequirement.fields.Name,
          kits: disposalRequirement.fields.Kits
        })
      })
      return disposalRequirements
    },
    distributorQuestions () {
      const distributorQuestions = []
      this.rawData.distributorQuestions.forEach(distributorQuestion => {
        distributorQuestions.push({
          id: distributorQuestion.id,
          question: distributorQuestion.fields.Question
        })
      })
      return distributorQuestions
    },
    levelOfTrainingDescriptors () {
      const levelOfTrainingDescriptors = []
      this.rawData.levelOfTrainingDescriptors.forEach(levelOfTrainingDescription => {
        levelOfTrainingDescriptors.push({
          id: levelOfTrainingDescription.id,
          description: levelOfTrainingDescription.fields.Description,
          rating: levelOfTrainingDescription.fields.Rating
        })
      })
      return levelOfTrainingDescriptors
    },
    easeOfUseDescriptors () {
      const easeOfUseDescriptors = []
      this.rawData.easeOfUseDescriptors.forEach(easeOfUseDescription => {
        easeOfUseDescriptors.push({
          id: easeOfUseDescription.id,
          description: easeOfUseDescription.fields.Description,
          rating: easeOfUseDescription.fields.Rating
        })
      })
      return easeOfUseDescriptors
    },
    pageContent () {
      const pageContent = []
      this.rawData.pageContent.forEach(page => {
        var content = page.fields.Content
        if (content) {
          content = md.render(content)
        }

        pageContent.push({
          id: page.id,
          handle: page.fields.Handle,
          title: page.fields.Title,
          content: content
        })
      })
      return pageContent
    }
  },
  render: h => h(App)
}).$mount('#app')
